import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RfqSettingsService } from '../../rfq-settings.service';

@Injectable({
    providedIn: 'root',
})
export class PurchaseRequisitionActiveGuard {
    private readonly dataService = inject(RfqSettingsService);

    canActivate(): Observable<boolean> {
        return this.dataService.purchaseRequisitionActive().pipe(map((dto) => dto.active));
    }
}
